const configService = {
  apiUrl: process.env.REACT_APP_API_WEB_BACKEND_URL,
  apiUrlAdmin: process.env.REACT_APP_API_ADMIN_BACKEND_URL,
};

export default configService;
